import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui

import { FormControl, InputLabel, Input } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';

import { useRouter } from 'src/routes/hooks';
import FormProvider, { RHFTextField } from 'src/components/hook-form';

import Iconify from 'src/components/iconify';

// import '../../../style.css';
import httpCommon from 'src/http-common';

// ----------------------------------------------------------------------

export default function InProgressStatus({ selectedRowID }) {
  const router = useRouter();

  const getId = localStorage.getItem('QRId'); // Id
  const getHsp = localStorage.getItem('Hsp'); // site_cd

  const SelectedUserId = selectedRowID; // UserId

  const [UserDt, setUserDt] = useState([]);

  const [UserDtImg, setUserDtImg] = useState([]);

  const [UserInfoData, setUserInfoData] = useState([]);
  const [phnNo, setPhnNo] = useState('');
  const Username = UserInfoData?.wkr_mst_requestor || '';
  const userdept = UserInfoData?.wkr_mst_dept || '';

  // Get Api All Data
  useEffect(() => {
    const fetchUserWorkListData = async () => {
      try {
        const response = await httpCommon.get(
          `/InProgressStatus.php?id=${getId}&siteCd=${getHsp}&UserId=${SelectedUserId}`
        );

        if (response.data.status === 'SUCCESS') {
          setUserDt(response.data.data1);
          setUserDtImg(response.data.data2);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchUserWorkListData(); // Call the function directly
  }, [getId, getHsp, SelectedUserId]);

  // chdck setting mode
  useEffect(() => {
    document.body.classList.remove('customNav');
    const handleThemeOnLoad = () => {
      const storedValue = localStorage.getItem('dataDark');
      // console.log("storedValue++", storedValue);
      if (storedValue === 'dark') {
        document.body.classList.add('custom-darkClass');
      } else {
        document.body.classList.remove('custom-darkClass');
      }
    };
    handleThemeOnLoad();
    return () => {
      document.body.classList.remove('custom-darkClass');
    };
  }, []);

  useEffect(() => {
    const fetchuserInfo = async () => {
      const requestData = {
        site_cd: getHsp,
        login_id: getId,
        mst_rowID: SelectedUserId,
      };
      try {
        const response = await httpCommon.post('/getUserWRInfo.php', requestData);
        if (response.data.status === 'SUCCESS') {
          setUserInfoData(response.data.data[0]);
          setPhnNo(response.data.data[0].wkr_mst_phone);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    // Call the fetchuserInfo function when the component mounts.
    fetchuserInfo();
  }, [getHsp, getId, SelectedUserId]);

  const selectedSchema = '';

  const methods = useForm({
    resolver: yupResolver(selectedSchema),
  });

  const formatDate = (dateString) => {
    const rawDate = new Date(dateString);
    const day = String(rawDate.getDate()).padStart(2, '0');
    const month = String(rawDate.getMonth() + 1).padStart(2, '0');
    const year = rawDate.getFullYear();
    const hours = String(rawDate.getHours()).padStart(2, '0');
    const minutes = String(rawDate.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };
  const statusText = UserDt[0]?.wko_mst_status === 'DO' ? 'In Progress' : '';
  return (
    <FormProvider methods={methods}>
      <Grid container spacing={4} className="RejectStatusCs">
        <Grid xs={12} md={5}>
          <Card sx={{ px: 3, pb: 5 }}>
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              <Iconify
                icon="codicon:git-pull-request-new-changes"
                style={{ marginBottom: '-5px' }}
              />{' '}
              Requester Information
            </Typography>

            <Box display="flex" flexDirection="column" rowGap={3}>
              {/* <TextField id="filled-basic" label="Employee ID"  inputProps={{ className: 'RejinputClass' }} disabled variant="filled"  defaultValue={getId} /> */}

              <div className="usrFrmFld">
                <FormControl>
                  <InputLabel>Employee ID</InputLabel>
                  <Input type="text" name="name" defaultValue={getId || ''} disabled />
                </FormControl>
              </div>
              {(() => {
                if (Username) {
                  return (
                    <div className="usrFrmFld">
                      <FormControl>
                        <InputLabel>Name</InputLabel>
                        <Input type="text" name="name" defaultValue={Username || ''} disabled />
                      </FormControl>
                    </div>
                  );
                }
                return (
                  <div className="fuWdt">
                    <RHFTextField
                      id="outlined-basic"
                      name="name"
                      label="Name"
                      variant="filled"
                      disabled
                    />
                  </div>
                );
              })()}
              <div>
                {(() => {
                  if (userdept) {
                    return (
                      <div className="usrFrmFld">
                        <FormControl>
                          <InputLabel>Department</InputLabel>
                          <Input
                            type="text"
                            name="department"
                            defaultValue={userdept || ''}
                            disabled
                          />
                        </FormControl>
                      </div>
                    );
                  }
                  return (
                    <div className="fuWdt">
                      <RHFTextField
                        id="outlined-basic"
                        name="department"
                        label="Department"
                        variant="filled"
                        disabled
                      />
                    </div>
                  );
                })()}
              </div>
              <div>
                {(() => {
                  if (phnNo) {
                    return (
                      <div className="usrFrmFld">
                        <FormControl>
                          <InputLabel>Contact No</InputLabel>
                          <Input type="text" name="contactNo" defaultValue={phnNo || ''} disabled />
                        </FormControl>
                      </div>
                    );
                  }
                  return (
                    <div className="fuWdt">
                      <RHFTextField
                        id="outlined-basic"
                        name="contactNo"
                        label="Contact No"
                        variant="filled"
                        disabled
                      />
                    </div>
                  );
                })()}
              </div>
            </Box>
          </Card>
        </Grid>

        <Grid xs={12} md={7}>
          <Card sx={{ px: 3, pb: 5 }}>
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              <Iconify icon="grommet-icons:workshop" style={{ marginBottom: '-5px' }} /> Work
              Request Information
            </Typography>

            <Box display="flex" flexDirection="column" rowGap={3}>
              <RHFTextField
                name="requestDate"
                variant="filled"
                label="Request Date"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                // value={UserDt[0]?.wkr_mst_org_date.date.split(' ')[0]}
                // value={formatDate(UserDt[0]?.wkr_mst_org_date.date)}
                value={
                  UserDt[0]?.wkr_mst_org_date.date
                    ? formatDate(UserDt[0]?.wkr_mst_org_date.date)
                    : ''
                }
              />

              <RHFTextField
                name="service"
                variant="filled"
                label="Service"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wkr_mst_service || ''}
              />
              <RHFTextField
                name="level"
                variant="filled"
                label="Level"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wkr_mst_location || ''}
              />
              <RHFTextField
                name="location"
                variant="filled"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                label="Room No/Location Description(*Please Specify Block, Level & Location Description) :"
                value={UserDt[0]?.wkr_mst_org_locn || ''}
              />
              <RHFTextField
                name="reqDescriptin"
                variant="filled"
                label="Request Description"
                multiline
                rows={4}
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wkr_mst_wr_descs || ''}
              />
              <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
                <Iconify
                  icon="material-symbols:settings-photo-camera-sharp"
                  style={{ marginBottom: '-5px' }}
                />{' '}
                Requested Images
              </Typography>
              <div className="image-grid">
                {UserDtImg?.map((image, index) => (
                  <div key={index} className="image-item">
                    <img src={image.attachment} alt={`Issue ${index + 1}`} className="grid-image" />
                  </div>
                ))}
              </div>
            </Box>
          </Card>
          <Card sx={{ px: 3, pb: 5 }} className="RejInfo">
            <Typography variant="subtitle2" sx={{ mb: 3, mt: 2 }}>
              <Iconify icon="mdi:file-cancel" style={{ marginBottom: '-5px' }} /> In Progress
              Information
            </Typography>
            <Box display="flex" flexDirection="column" rowGap={3}>
              <RHFTextField
                name="Order Number"
                variant="filled"
                label="Work Order Number"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wko_mst_wo_no || ''}
              />

              <RHFTextField
                name="OrderStatu"
                variant="filled"
                label="Work Order Status"
                disabled
                inputProps={{ className: 'RejinputClass' }}
                value={UserDt[0]?.wrk_sts_desc || ''}
              />

              <RHFTextField
                name="workcorr"
                variant="filled"
                label="Work Corrective Action "
                disabled
                className="wkoDetCorr"
                value={UserDt[0]?.wko_det_corr_action || ''}
              />
            </Box>
          </Card>
          <Stack alignItems="inherit" sx={{ mt: 2 }}>
            {/* <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                    Save
              </LoadingButton> */}
          </Stack>
        </Grid>
      </Grid>
    </FormProvider>
  );
}

InProgressStatus.propTypes = {
  selectedRowID: PropTypes.object,
};
